
<mat-card class="filter settingHeader">
  <div class="name">
    Login Details
  </div>
  <div class="quickAction">    
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search">
    </mat-form-field>
  </div>
</mat-card>






  
<mat-card class="mat-table-cs">
  <mat-table #table [dataSource]="dataSource" matSort matSortDisableClear matSortDirection="asc">
   
    <ng-container matColumnDef="fullName">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.fullName}}</mat-cell>
    </ng-container>
  
    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.email}} </mat-cell>
    </ng-container>

   
    <ng-container matColumnDef="organizationName">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Organization Name </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.organizationName}} </mat-cell>
    </ng-container>

   
    <ng-container matColumnDef="officeName">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Office Name </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.officeName}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="lastLogin">
      <mat-header-cell class="last" *matHeaderCellDef mat-sort-header> Last Login </mat-header-cell>
      <mat-cell class="last-cell" *matCellDef="let element"> {{element.lastLogin+'Z' | date:'MM/dd/yyyy'}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="totalLoginCount">
      <mat-header-cell class="last" *matHeaderCellDef mat-sort-header> Total Login </mat-header-cell>
      <mat-cell class="last-cell" *matCellDef="let element"> {{element.totalLoginCount}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="last30DaysLoginCount">
      <mat-header-cell class="last" *matHeaderCellDef mat-sort-header> Last 30 days </mat-header-cell>
      <mat-cell  class="last-cell" *matCellDef="let element"> {{element.last30DaysLoginCount}} </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
</mat-card>

  
  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>







